import React, { useState } from "react";
import Routes from "./Components/Routes";
import SecaoProvider from "./context/SecaoContext";
import ConfigProvider from "./context/ConfigContext";
import GlobalStyle from "./shared/GlobalStyle";
import Stage from "./shared/Stage";

function App() {
  return (
    <ConfigProvider>
      <SecaoProvider>
        <GlobalStyle />
        <Stage>
          <Routes />
        </Stage>
      </SecaoProvider>
    </ConfigProvider>
  );
}

export default App;
